// extracted by css-extract-rspack-plugin
export default {"icon":"recommendation-fragment__Icon_icon__Wj21E"};